import { get } from 'lodash';

export default class CourseAuthoringSettings {
  enabled: boolean;

  constructor(json: any) {
    this.enabled = !!get(json, 'enabled');
  }
}
